
import React from "react"
import { render } from "react-dom"
import { Provider } from "react-redux"
import { createBrowserHistory } from "history";
import { OidcProvider } from 'redux-oidc'
import { ConnectedRouter } from "react-router-redux"
import configureStore from "./redux/store"
import userManager from "./userManager"
import App from "./App"
import registerServiceWorker from "./registerServiceWorker"

const history = createBrowserHistory()
const store = configureStore()

render(
  <Provider store={store}>
   <OidcProvider userManager={userManager} store={store} >
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
    </OidcProvider>  
  </Provider>,
  document.getElementById("root"),
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js